import React from 'react';
import { Loader2, Upload, X } from 'lucide-react';
import { Button } from '../../../ui/button';
import { Card } from '../../../ui/card';
import { Textarea } from '../../../ui/textarea';
import {
  CAMPAIGN_OPTIONS,
  DAD_STAGE_OPTIONS,
  SOURCE_OPTIONS,
  WARMTH_OPTIONS,
} from './memberConstants';

const DadImportModal = ({
  open,
  onClose,
  importDefaults,
  setImportDefaults,
  importCsv,
  setImportCsv,
  onFileChange,
  onSubmit,
  importingDads,
}) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto bg-black/50 p-4">
      <div className="flex min-h-full items-start justify-center pt-8">
        <Card className="max-h-[calc(100vh-4rem)] w-full max-w-2xl overflow-y-auto border-[#2a2a32] bg-[#1e1e24] p-6">
          <div className="mb-4 flex items-center justify-between">
            <div>
              <h3 className="text-lg font-semibold text-white">Import Dads from Luma CSV</h3>
              <p className="mt-1 text-sm text-gray-400">Paste a Luma export or load a CSV file. We will update existing dads by email and create new prospects when needed.</p>
            </div>
            <button onClick={onClose} className="text-gray-400 hover:text-white">
              <X className="h-5 w-5" />
            </button>
          </div>

          <div className="grid gap-4 md:grid-cols-2">
            <div>
              <label className="text-sm text-gray-400">Default relationship stage</label>
              <select
                value={importDefaults.relationship_stage}
                onChange={(e) => setImportDefaults((prev) => ({ ...prev, relationship_stage: e.target.value }))}
                className="mt-1 w-full rounded-lg border border-[#2a2a32] bg-[#16161a] px-3 py-2 text-white"
              >
                {DAD_STAGE_OPTIONS.filter((option) => option.value !== 'all').map((option) => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="text-sm text-gray-400">Default campaign</label>
              <select
                value={importDefaults.campaign_type}
                onChange={(e) => setImportDefaults((prev) => ({ ...prev, campaign_type: e.target.value }))}
                className="mt-1 w-full rounded-lg border border-[#2a2a32] bg-[#16161a] px-3 py-2 text-white"
              >
                {CAMPAIGN_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="text-sm text-gray-400">Default source</label>
              <select
                value={importDefaults.source}
                onChange={(e) => setImportDefaults((prev) => ({ ...prev, source: e.target.value }))}
                className="mt-1 w-full rounded-lg border border-[#2a2a32] bg-[#16161a] px-3 py-2 text-white"
              >
                {SOURCE_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="text-sm text-gray-400">Default warmth</label>
              <select
                value={importDefaults.warmth}
                onChange={(e) => setImportDefaults((prev) => ({ ...prev, warmth: e.target.value }))}
                className="mt-1 w-full rounded-lg border border-[#2a2a32] bg-[#16161a] px-3 py-2 text-white"
              >
                {WARMTH_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>{option.label}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="mt-4">
            <label className="mb-2 block text-sm text-gray-400">CSV content</label>
            <div className="mb-3 flex flex-wrap items-center gap-3">
              <label className="inline-flex cursor-pointer items-center gap-2 rounded-lg border border-[#2a2a32] bg-[#16161a] px-3 py-2 text-sm text-white hover:bg-[#202028]">
                <Upload className="h-4 w-4" />
                Load CSV file
                <input type="file" accept=".csv,text/csv" className="hidden" onChange={onFileChange} />
              </label>
              <span className="text-xs text-gray-500">Expected columns: name, email, phone, source, children ages, biggest pressure area, plus any extra Luma registration answers.</span>
            </div>
            <Textarea
              value={importCsv}
              onChange={(e) => setImportCsv(e.target.value)}
              placeholder="Paste the Luma CSV export here..."
              className="min-h-[260px] border-[#2a2a32] bg-[#16161a] font-mono text-xs text-white"
            />
          </div>

          <div className="flex gap-3 pt-5">
            <Button
              variant="outline"
              onClick={onClose}
              className="flex-1 border-[#2a2a32] text-white hover:bg-[#16161a]"
            >
              Cancel
            </Button>
            <Button
              onClick={onSubmit}
              disabled={importingDads || !importCsv.trim()}
              className="flex-1 gap-2 bg-aqua text-charcoal hover:bg-aqua-dark"
            >
              {importingDads ? <Loader2 className="h-4 w-4 animate-spin" /> : <Upload className="h-4 w-4" />}
              Import Dads
            </Button>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default DadImportModal;
